import * as React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * VWO SmartCode component for Enterprise website personalization and A/B testing.
 * This component loads the VWO SmartCode asynchronously in the <head> section.
 *
 * According to VWO documentation for React Helmet:
 * - SmartCode should be placed before the </head> tag
 * - Use template literals (back-ticks) for the script content
 * - Preconnect link improves performance by establishing early connection
 *
 * @see https://help.vwo.com/hc/en-us/articles/360019422834-Configuring-the-VWO-SmartCode-for-Your-Website
 */
function VWOTag() {
  return (
    <Helmet>
      {/* VWO Async SmartCode v3.0 */}
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type="text/javascript" id="vwoCode">
        {`window._vwo_code || (function() {
    var account_id = 1193425,
        version = 3.0,
        settings_tolerance = 2000,
        hide_element = 'body',
        hide_element_style =
        'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important';
    /* DO NOT EDIT BELOW THIS LINE */
    var n=window,i=document;if(-1<i.URL.indexOf('__vwo_disable__')||n._vwo_code)return;var t=!1,r=i.currentScript,e={sT:settings_tolerance,hES:hide_element_style,hE:hide_element};try{e=Object.assign(e,JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config')))}catch(e){}var code={script:r,nonce:r.nonce,settings_tolerance:function(){return e.sT},hide_element:function(){return performance.getEntriesByName('first-contentful-paint')[0]?'':e.hE},hide_element_style:function(){return'{'+e.hES+'}'},getVersion:function(){return version},finish:function(){var e;!t&&(t=!0,e=i.getElementById('_vis_opt_path_hides'))&&e.parentNode.removeChild(e)},finished:function(){return t},addScript:function(e){var t=i.createElement('script');t.src=e,r.nonce&&t.setAttribute('nonce',r.nonce),t.fetchPriority='high',i.head.appendChild(t)},init:function(){n._vwo_settings_timer=setTimeout(function(){code.finish()},this.settings_tolerance());var e,t=this.hide_element();t&&((e=i.createElement('style')).id='_vis_opt_path_hides',r.nonce&&e.setAttribute('nonce',r.nonce),e.textContent=t+this.hide_element_style(),i.head.appendChild(e)),this.addScript('https://dev.visualwebsiteoptimizer.com/tag/'+account_id+'.js')}};n._vwo_code=code;code.init();})();`}
      </script>
    </Helmet>
  );
}

export default VWOTag;
